export type LabelKind = "square" | "framed";

export interface LabelPreset {
  key: string;
  code: string; // Marketing/manufacturer code e.g., "Avery 22806"
  widthIn: number; // width in inches
  heightIn: number; // height in inches
  perSheet: number;
  kind: LabelKind;
  rotateCCW90OnSheet?: boolean; // true only for rectangular framed sets
  isDefault?: boolean;
}

// Authoritative catalog
export const LABEL_PRESETS: LabelPreset[] = [
  // Square (no frame)
  { key: "square-large", code: "Avery 22806", widthIn: 2, heightIn: 2, perSheet: 12, kind: "square", isDefault: true },
  { key: "square-medium", code: "Avery 22805", widthIn: 1.5, heightIn: 1.5, perSheet: 24, kind: "square" },
  { key: "square-small", code: "Avery 5658", widthIn: 1, heightIn: 1, perSheet: 48, kind: "square" },

  // Framed (rectangular) — rotate on sheet only
  { key: "rect-large", code: "Avery 6572", widthIn: 2, heightIn: 2 + 5 / 8, perSheet: 15, kind: "framed", rotateCCW90OnSheet: true, isDefault: true },
  { key: "rect-medium", code: "Avery 22828", widthIn: 1.25, heightIn: 1.75, perSheet: 24, kind: "framed", rotateCCW90OnSheet: true },
  { key: "rect-small", code: "Presta 94219", widthIn: 1, heightIn: 1.5, perSheet: 32, kind: "framed", rotateCCW90OnSheet: true },
];

export function getDefaultPreset(kind: LabelKind): LabelPreset {
  const p = LABEL_PRESETS.find((x) => x.kind === kind && x.isDefault);
  if (!p) throw new Error(`No default preset for kind=${kind}`);
  return p;
}

export function presetsFor(kind: LabelKind): LabelPreset[] {
  return LABEL_PRESETS.filter((x) => x.kind === kind);
}

export function getPresetByKey(key: string): LabelPreset | undefined {
  return LABEL_PRESETS.find((x) => x.key === key);
}


